import { getModuleFederatedName, root, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import {
    ACCOUNT_SIDEBAR_LOYALTY,
    LOYALTY_POINTS_INFO,
    LOYALTY_TIER_INFO,
    LOYALTY_DASHBOARD,
    LOYALTY_SUBMIT_A_RECEIPT,
    LOYALTY_EARN_POINTS,
    LOYALTY_POINTS_HISTORY,
    LOYALTY_BENEFITS,
    LOYALTY_REWARDS,
    LOYALTY_POINT_BENEFIT,
    LOYALTY_BIRTHDAY,
    LOYALTY_MARKETING_PAGE,
    LOYALTY_LANDING_PAGE
} from '@estee/elc-service-view-names';
import serviceNames, { LoyaltyService } from '~setup/LoyaltyService';
import { serviceBusBaseClass } from '~setup/ServiceBus';
import { serviceQueries } from '@estee/elc-service-bus';
import { startTranslations } from './serviceConfig';
import { ConfigRepositoryVulcan } from './internal/repositories/ConfigRepositoryVulcan';
import './styles/tailwind.css';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

LoyaltyService.setViews(name, getModuleFederatedName(name), version, [
    ACCOUNT_SIDEBAR_LOYALTY,
    LOYALTY_POINTS_INFO,
    LOYALTY_TIER_INFO,
    LOYALTY_DASHBOARD,
    LOYALTY_SUBMIT_A_RECEIPT,
    LOYALTY_EARN_POINTS,
    LOYALTY_POINTS_HISTORY,
    LOYALTY_BENEFITS,
    LOYALTY_REWARDS,
    LOYALTY_POINT_BENEFIT,
    LOYALTY_BIRTHDAY,
    LOYALTY_MARKETING_PAGE,
    LOYALTY_LANDING_PAGE
]);

// This can be removed after all pincer services support pincer-component-renderer
// @ts-ignore
root.ServiceRegistry[name].isVulcan = true;

// @ts-ignore
ServiceManager.ecommStarted = true;
root.GlobalServiceBus.registerQueryProvider(serviceQueries.GET_CONFIG, () =>
    new ConfigRepositoryVulcan().getConfigs()
);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.loyaltyService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBus: {
        serviceBusBaseClass
    }
});

(() => {
    startTranslations({ baseUrl: '', clientId: '', businessUnitId: '', environment: 'dev' });
})();
